import React from 'react';

// Official IMDb wordmark (yellow rounded badge with black "IMDb" text)
const ImdbIcon = ({ size = 18, className = '' }) => (
  <svg
    width={size * (64 / 32)}
    height={size}
    viewBox="0 0 64 32"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="64" height="32" rx="5" fill="#F5C518" />
    <text
      x="32"
      y="23"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontWeight="700"
      fontSize="18"
      fill="#000000"
    >
      IMDb
    </text>
  </svg>
);

export default ImdbIcon;
